import { SelectHTMLAttributes, forwardRef } from 'react';
import { COLORS } from '../../constants/theme';

interface SelectOption {
  id: string;
  name: string;
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: readonly SelectOption[];
  error?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, options, error, className = '', id, ...props }, ref) => {
    const selectId = id || label.toLowerCase().replace(/\s+/g, '-');

    return (
      <div className="space-y-1">
        <label
          htmlFor={selectId}
          className="block text-sm font-medium"
          style={{ color: COLORS.text.secondary }}
        >
          {label}
        </label>
        <select
          ref={ref}
          id={selectId}
          className={`w-full px-3 py-2 rounded-md focus:outline-none focus:ring-2 ${className}`}
          style={{
            backgroundColor: COLORS.inputBg,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: error ? COLORS.negative : COLORS.inputBorder,
            color: COLORS.text.primary,
          }}
          {...props}
        >
          {options.map((option) => (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          ))}
        </select>
        {error && (
          <p className="text-sm" style={{ color: COLORS.negative }}>
            {error}
          </p>
        )}
      </div>
    );
  }
);

Select.displayName = 'Select';
